// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import type { Crop, Image, PersistedImage } from '../../types'
import { translateFunc, translations } from '../../../shared/localize'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 240px;
  padding: 0 12px;
  background-color: #ffffff;
  border: 1px solid #cccccc;
`
const ContainerCanvas: StyledComponent<Object, any, any> = styled.div`
  margin: 0 -12px;
  text-align: center;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  display: inline-block;
  vertical-align: top;
  text-decoration: none;
  line-height: 1.1;
  margin: 10px 0 0 7px;
  font-weight: bold;
  color: #333;
`
const Description: StyledComponent<Object, any, any> = styled.div`
  padding: 0 0 7px;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  max-height: 131px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 7px 7px 0;
  max-width: 100%;
  font-size: 12px;
  line-height: 1.3;
  color: #000;
`
const Link: StyledComponent<Object, any, any> = styled.div`
  color: #a6a6a6;
  font-size: 11px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 238px;
  box-sizing: border-box;
  white-space: nowrap;
  padding-left: 4px;
`
const ButtonWrapper: StyledComponent<Object, any, any> = styled.div`
  text-align: center;
  padding: 10px 0;
`
const Button: StyledComponent<Object, any, any> = styled.div`
  width: 210px;
  font-size: 11px;
  text-transform: uppercase;
  display: inline-block;
  line-height: 32px;
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.15);
  height: 32px;
  padding: 0 15px;
  outline: none;
  border-width: 0;
  transition: background-color .7s ease, color .7s ease;
  position: relative;
  background: #00abf1;
  color: #fff;
  text-shadow: 0 -1px 0 rgba(3, 3, 3, 0.3);
  vertical-align: top;
  border-radius: 3px;
  box-sizing: border-box;
}
`

type Props = {|
  title: string,
  description: string,
  url: string,
  image: ?Image | ?PersistedImage,
  imageCrop: ?Crop,
  linkButton: string
|}

const t = translateFunc(translations.provider_previews.target_mail)

export default function TmBanner(props: Props) {
  const { url, title, description, imageCrop, image, linkButton } = props

  return (
    <Wrapper>
      <ContainerCanvas>
        <OptionalResponsibleImage image={image} imageCrop={imageCrop} width={238} ratio={1} />
      </ContainerCanvas>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <Link>{url}</Link>
      <ButtonWrapper>
        <Button>{t(linkButton)}</Button>
      </ButtonWrapper>
    </Wrapper>
  )
}
